module.exports = "chart {\n  display: block;\n  margin: auto; }\n\n.preLoader {\n  display: block;\n  margin: auto;\n  width: 175px;\n  height: 175px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/charts/high-stock-chart/high-stock-chart.component.sass
// module id = ./src/app/charts/high-stock-chart/high-stock-chart.component.sass
// module chunks = main